export default __webpack_public_path__ + "static/media/brx_logo_vertical.dace8643.webp";